import React, { ReactNode } from "react";
import s from "../ComparisonTable.module.scss";
import cn from "classnames";
import RichText from "../../Common/RichText";
import type { RichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";
import { isRichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";

type HeaderColumnProps = {
  label?: string;
  title?: string;
  description?: RichTextContent;
  image?: ReactNode;
  buttons?: ReactNode;
  isHighlighted?: boolean;
  isBeforeHighlighted?: boolean;
  isAfterHighlighted?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const HeaderColumn: React.FC<HeaderColumnProps> = ({
  label,
  title,
  description,
  image,
  buttons,
  isHighlighted,
  isBeforeHighlighted,
  isAfterHighlighted,
  ...props
}) => {
  return (
    <div
      className={cn(s.headerCell, {
        [s.highlighted]: isHighlighted,
        [s.beforeHighlighted]: isBeforeHighlighted,
        [s.afterHighlighted]: isAfterHighlighted,
      })}
      role="columnheader"
      {...props}
    >
      {label && <div className={s.label}>{label}</div>}

      <div className={s.content}>
        {image && <div className={s.imageContainer}>{image}</div>}

        {title && <div className={s.title}>{title}</div>}

        {isRichTextContent(description) && description && (
          <RichText content={description} className={s.description} />
        )}

        {buttons && <div className={s.buttons}>{buttons}</div>}
      </div>
    </div>
  );
};

export default HeaderColumn;
